/* eslint no-unused-expressions: 0 */
import React, { Fragment, useEffect, useRef } from 'react';
import Observer from 'react-intersection-observer';
import { GAfireEvent } from './Tracking';
import { isEs } from "../libs/lang";

import {fireTag} from '../libs/analytics';

const Footer = ({footerStyles, id, showSocial = true, styleType = '', shouldBeInert, activePage, enableScrollGA}) => {


	const curYear = new Date();
	const containerRef = useRef(null)

	useEffect(() => {
		if (containerRef.current.node) {
			if (shouldBeInert) {
				containerRef.current.node.setAttribute('inert', '');
				// containerRef.current.node.setAttribute('tabIndex', '-1');
				// containerRef.current.node.setAttribute('aria-hidden', 'true');
			}
			else {
				containerRef.current.node.removeAttribute('inert');
				// containerRef.current.node.removeAttribute('tabIndex');
				// containerRef.current.node.removeAttribute('aria-hidden');
			}
		}
	}, [shouldBeInert])

	let scrollFooter = false;

	let count = 0;

	useEffect(() => {
		window.addEventListener('scroll',()=>{
			if(count === 0 && !scrollFooter && document.querySelector('footer').getBoundingClientRect().top <= window.innerHeight){
				scrollFooter = true;
				fireTag('footer');
				count++;
			}
		});
	},[]);

	return (
		<Observer
			tag='footer'
			id={id}
			as="footer"
			className={footerStyles}
			threshold={0.25}
			triggerOnce
			ref={containerRef}
			onChange={inView => {
				if (inView && enableScrollGA) {
					//fireTag("footer");
					//GAfireEvent(`${activePage}_scroll_footer`);
				}
			}}

		>
			<div className="container">
				{showSocial && (<div className="social">
					<ul>{
							isEs() ? 
								<>
									<li><a lang="en" href="https://www.facebook.com/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/facebook.svg`} alt="Facebook Icono abre una superposición de salida de terceros."/></a></li>
									<li><a lang="en" href="https://www.linkedin.com/company/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/linkedin.svg`} alt="LinkedIn Icono abre una superposición de salida de terceros."/></a></li>
									<li><a lang="en" href="https://instagram.com/wellsfargo/" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/instagram.svg`} alt="Instagram Icono abre una superposición de salida de terceros."/></a></li>
									<li><a lang="en" href="https://www.pinterest.com/wellsfargo/" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/pinterest.svg`} alt="Pinterest Icono abre una superposición de salida de terceros."/></a></li>
									<li><a lang="en" href="https://www.youtube.com/user/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/youtube.svg`} alt="YouTube Icono abre una superposición de salida de terceros."/></a></li>
									<li><a lang="en" href="https://twitter.com/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/twitter.svg`} alt="Twitter Icono abre una superposición de salida de terceros."/></a></li>
								</>
								:
								<>
									<li><a lang="en" href="https://www.facebook.com/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/facebook.svg`} alt="Facebook link opens an exit overlay"/></a></li>
									<li><a lang="en" href="https://www.linkedin.com/company/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/linkedin.svg`} alt="LinkedIn link opens an exit overlay"/></a></li>
									<li><a lang="en" href="https://instagram.com/wellsfargo/" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/instagram.svg`} alt="Instagram link opens an exit overlay"/></a></li>
									<li><a lang="en" href="https://www.pinterest.com/wellsfargo/" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/pinterest.svg`} alt="Pinterest link opens an exit overlay"/></a></li>
									<li><a lang="en" href="https://www.youtube.com/user/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/youtube.svg`} alt="Youtube link opens an exit overlay"/></a></li>
									<li><a lang="en" href="https://twitter.com/wellsfargo" target="_blank" rel="noreferrer"><img src={`${process.env.PUBLIC_URL}/images/twitter.svg`} alt="Twitter link opens an exit overlay"/></a></li>		
								</>
						}
					</ul>
				</div>)}
				{window.location.pathname.indexOf('/map/') > -1 && (
					<>
						<p className="body">Nonprofit name and address are from the 2021 Internal Revenue Service tax filings. Other nonprofit data are from the 2021 Wells Fargo and Wells Fargo Foundation list of grantees.</p>
						<p><a className="linkout" href="https://www.mapbox.com/about/maps/" target="_blank" rel="noreferrer">Maps &copy; Mapbox &copy; OpenStreetMap</a></p>
					</>
				)}
				<div className={`external-links ${styleType}`}>
					<ul>
						{
							isEs() ?
								<>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/privacy-security/" rel="noreferrer">Privacidad, <span lang="en">cookies</span>, seguridad y asuntos legales</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/privacy-security/notice-of-data-collection/" rel="noreferrer">Aviso sobre recopilación de datos</a>
									</li>
									<li>
										<a id="ot-sdk-link" className="ot-sdk-show-settings" href={'#'} aria-label={'No Vendan ni Compartan Mi Información Personal'}>No Vendan ni Compartan Mi Información Personal</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/privacy-security/terms/" rel="noreferrer">Términos generales de uso</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/online-banking/online-access-agreement/" rel="noreferrer">Contrato de Acceso por Internet</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/privacy-security/fraud/report/" rel="noreferrer">Reporte el fraude</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/about/" rel="noreferrer">Acerca de <span lang="en">Wells Fargo</span></a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/about/careers/" rel="noreferrer">Empleo (en inglés)</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/about/diversity/" rel="noreferrer">Inclusión y accesibilidad</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/sitemap" rel="noreferrer">Mapa del sitio</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/es/" rel="noreferrer">Página principal</a>
									</li>
								</> :
								<>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/privacy-security/" rel="noreferrer" aria-label="Privacy, Cookies, Security &amp; Legal link opens in new window">Privacy, Cookies, Security & Legal</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/privacy-security/notice-of-data-collection/" rel="noreferrer" aria-label="Notice of Data Collection link opens in new window">Notice of Data Collection</a>
									</li>
									<li>
										<a id="ot-sdk-link" className="ot-sdk-show-settings" href={'#'} aria-label={'Do Not Sell or Share My Personal Information'}>Do Not Sell or Share My Personal Information</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/privacy-security/terms/" rel="noreferrer" aria-label="General Terms of Use link opens in new window">General Terms of Use</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/online-banking/online-access-agreement/" rel="noreferrer" aria-label="Online Access Agreement link opens in new window">Online Access Agreement</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/privacy-security/fraud/report/" rel="noreferrer" aria-label="Report Fraud link opens in new window">Report Fraud</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/about/" rel="noreferrer" aria-label="About Wells Fargo link opens in new window">About Wells Fargo</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/about/careers/" rel="noreferrer" aria-label="Careers link opens in new window">Careers</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/about/diversity/" rel="noreferrer" aria-label="Inclusion &amp; Accessibility link opens in new window">Inclusion &amp; Accessibility</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/sitemap" rel="noreferrer" aria-label="Sitemap link opens in new window">Sitemap</a>
									</li>
									<li>
										<a target="_blank" href="https://www.wellsfargo.com/" rel="noreferrer" aria-label="Home link opens in new window">Home</a>
									</li>
								</>
						}
					</ul>
				</div>
				{window.location.pathname.indexOf('/map/') > -1 && (
					<hr/>
				)}
				{activePage !== 'home' && activePage !== 'sustainability' && activePage !== 'housing' && (<p id="copyright">Deposit products offered by Wells Fargo Bank, N.A. Member FDIC.</p>)}
				<p>&copy; 1999 - {curYear.getFullYear()} <span lang="en">Wells Fargo.</span> {activePage !== 'home' && activePage !== 'sustainability' && activePage !== 'housing' && `NMLSR ID 399801`}</p>
			</div>
		</Observer>
	);
};

export default Footer;
